export default __webpack_public_path__ + "svg/calendar/2025/5/mayo.svg?b72190c6";